(function () {
  var selector = '.dg-collection-hero .dg-subcats';
  var parallaxSelector = '.dg-collection-hero .dg-hero__media';
  var bindings = new WeakMap();
  var parallaxBindings = new WeakMap();

  function updateState(section) {
    var row = section.querySelector('.dg-subcats__row');

    if (!row) {
      return;
    }

    var maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
    var scrollLeft = Math.min(maxScroll, Math.max(0, row.scrollLeft));
    var edgeTolerance = 8;
    var isScrollable = maxScroll > 1;

    section.classList.toggle('is-scrollable', isScrollable);
    section.classList.toggle('can-scroll-left', isScrollable && scrollLeft > edgeTolerance);
    section.classList.toggle('can-scroll-right', isScrollable && scrollLeft < maxScroll - edgeTolerance);
  }

  function bind(section) {
    var row = section.querySelector('.dg-subcats__row');
    var currentBinding = bindings.get(section);

    if (!row) {
      return;
    }

    if (currentBinding) {
      updateState(section);
      return;
    }

    var frame = 0;
    var resizeObserver;

    function requestUpdate() {
      if (frame) {
        return;
      }

      frame = window.requestAnimationFrame(function () {
        frame = 0;
        updateState(section);
      });
    }

    row.addEventListener('scroll', requestUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(row);
    } else {
      window.addEventListener('resize', requestUpdate);
    }

    bindings.set(section, function () {
      row.removeEventListener('scroll', requestUpdate);

      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', requestUpdate);
      }
    });

    requestUpdate();
  }

  function unbind(section) {
    var cleanup = bindings.get(section);

    if (!cleanup) {
      return;
    }

    cleanup();
    bindings.delete(section);
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function readNumberStyle(element, property, fallback) {
    var value = parseFloat(window.getComputedStyle(element).getPropertyValue(property));
    return Number.isFinite(value) ? value : fallback;
  }

  function updateParallax(media) {
    var photo = media.querySelector('.dg-hero__photo');

    if (!photo) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      photo.style.setProperty('--dg-hero-parallax-y', '0px');
      return;
    }

    var rect = media.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    if (rect.bottom < 0 || rect.top > viewportHeight) {
      return;
    }

    var maxCap = readNumberStyle(media, '--dg-hero-parallax-max', 132);
    var maxOffset = Math.min(maxCap, rect.height * 0.46);
    var visibilityProgress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
    var offset = (visibilityProgress - 0.5) * 2 * maxOffset;

    photo.style.setProperty('--dg-hero-parallax-y', offset.toFixed(1) + 'px');
  }

  function bindParallax(media) {
    var currentBinding = parallaxBindings.get(media);

    if (currentBinding) {
      updateParallax(media);
      return;
    }

    var frame = 0;

    function requestUpdate() {
      if (frame) {
        return;
      }

      frame = window.requestAnimationFrame(function () {
        frame = 0;
        updateParallax(media);
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    parallaxBindings.set(media, function () {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
    });

    requestUpdate();
  }

  function unbindParallax(media) {
    var cleanup = parallaxBindings.get(media);

    if (!cleanup) {
      return;
    }

    cleanup();
    parallaxBindings.delete(media);
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(selector)) {
      bind(scope);
    }

    scope.querySelectorAll(selector).forEach(bind);

    if (scope.matches && scope.matches(parallaxSelector)) {
      bindParallax(scope);
    }

    scope.querySelectorAll(parallaxSelector).forEach(bindParallax);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.matches && event.target.matches(selector)) {
      unbind(event.target);
    }

    if (event.target.matches && event.target.matches(parallaxSelector)) {
      unbindParallax(event.target);
    }

    event.target.querySelectorAll(selector).forEach(unbind);
    event.target.querySelectorAll(parallaxSelector).forEach(unbindParallax);
  });
})();
